import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { AuthOptions } from "./AuthOptions";
import { AuthRegisterEmail } from "./AuthRegisterEmail";
import { AuthForgotPassword } from "./AuthForgotPassword";
import "./AuthModal.css";
import { AuthLoginEmailWithRecaptcha } from "./AuthLoginEmailWithRecaptcha";
import yqLogo from "../../../assets/img/homeV2/yq-logo.png";

export const AuthModal = ({ show, onHide, defaultView = "options" }) => {
  const [view, setView] = useState(defaultView);

  // Reset view when modal opens
  useEffect(() => {
    if (show) {
      setView(defaultView);
    }
  }, [show, defaultView]);

  const renderView = () => {
    switch (view) {
      case "options":
        return <AuthOptions setView={setView} onHide={onHide} />;
      case "login":
        return (
          <AuthLoginEmailWithRecaptcha setView={setView} onHide={onHide} />
        );
      case "register":
        return <AuthRegisterEmail setView={setView} onHide={onHide} />;
      case "forgotPassword":
        return <AuthForgotPassword setView={setView} />;
      default:
        return <AuthOptions setView={setView} onHide={onHide} />;
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="custom-modal">
      <div className="auth-modal-content">
        <Modal.Header closeButton className="auth-modal-header"></Modal.Header>
        <Modal.Body className="auth-modal-body">
          <img src={yqLogo} alt="Yuva Quest" className="auth-modal-logo" />
          <div className="auth-modal-name">YUVA QUEST</div>
          {renderView()}
        </Modal.Body>
      </div>
    </Modal>
  );
};
